module.exports = __webpack_public_path__ + "img/0220805141334.f34ea0af.jpg";